import { render, staticRenderFns } from "./AddStoreTag.vue?vue&type=template&id=752a5a0b&"
import script from "./AddStoreTag.vue?vue&type=script&lang=js&"
export * from "./AddStoreTag.vue?vue&type=script&lang=js&"
import style0 from "./AddStoreTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports